import React, { useEffect } from 'react';
import Head from 'next/head';

import { makeScript, preConnect } from '../script';

export interface ImpactScriptProps {
  accountID?: string;
}

/**
 * Script function.
 *
 * @param ctx
 */
function im(ctx: ImpactScriptProps) {
  if (ctx.accountID) {
    /*eslint-disable */
    // prettier-ignore
    (function(a,b,c,d,e){
      e['ire_o']=c;
      e[c]=e[c]||function(){
          (e[c].a=e[c].a||[]).push(arguments)
        };
      var f=d.createElement(b) as HTMLScriptElement;
      var g=d.getElementsByTagName(b)[0];
      f.async=true;
      f.src=a;
      g&&g.parentNode&&g.parentNode.insertBefore(f,g);
    })('//d.impactradius-event.com/'+ctx.accountID+'.js','script','ire',document,window);
    /*eslint-enable */
  }
}

export const ImpactScript = (props: ImpactScriptProps): JSX.Element => {
  useEffect(() => {
    if (window.ire) {
      window.ire('identify', { customerId: '', customerEmail: '' });
    }
  }, []);

  const accountID = props.accountID || process.env.NEXT_PUBLIC_IMPACT_ACCOUNT_ID;

  return (
    <Head>
      {preConnect('//d.impactradius-event.com', accountID || false)}
      {makeScript(im, { accountID })}
    </Head>
  );
};

export default ImpactScript;
